import React from 'react';
import { MaskedInput } from 'antd-mask-input';
import { normalizeFederalTaxNumber } from 'util/formatters';
import { configManager } from 'react-structure-admin';
import { Input } from 'antd';

const allowAlphanumericFederalTaxNumber = () => {
  return configManager.getConfig().allowAlphanumericFederalTaxNumber ?? false;
};

const formatFederalTaxNumber = (value) => {
  const clean = normalizeFederalTaxNumber(value) ?? '';

  const sanitized = allowAlphanumericFederalTaxNumber()
    ? clean
    : clean.replace(/\D/g, '');

  const isCnpj =
    sanitized.length > 11 ||
    (allowAlphanumericFederalTaxNumber() && /[A-Z]/.test(sanitized));

  if (!isCnpj) {
    const cpf = sanitized.replace(/\D/g, '');
    return cpf
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  }

  const body = sanitized.slice(0, 12);
  const tail = sanitized.slice(12, 14).replace(/\D/g, '');
  const cnpj = (body + tail).slice(0, 14);

  return cnpj
    .replace(/(\w{2})(\w)/, '$1.$2')
    .replace(/(\w{2})\.(\w{3})(\w)/, '$1.$2.$3')
    .replace(/\.(\w{3})(\w{1,4})/, '.$1/$2')
    .replace(/(\w{4})(\d{1,2})$/, '$1-$2');
};

const FederalTaxNumberInputMask = ({
  isLegalPerson,
  value = '',
  onChange,
  ...rest
}) => {
  const cnpjMask = allowAlphanumericFederalTaxNumber()
    ? '##.###.###/####-11'
    : '11.111.111/1111-11';

  if (isLegalPerson != null) {
    return (
      <MaskedInput
        mask={isLegalPerson ? cnpjMask : '111.111.111-11'}
        value={value}
        onChange={onChange}
        {...rest}
      />
    );
  }

  const handleChange = (e) => {
    onChange?.({
      ...e,
      target: { ...e.target, value: formatFederalTaxNumber(e.target.value) }
    });
  };

  return (
    <Input value={value} onChange={handleChange} {...rest} maxLength={18} />
  );
};

export default FederalTaxNumberInputMask;
